module.exports = __webpack_public_path__ + "img/xw.79a9b8de.png";